import { ActiveField, ActiveModel } from '@alt-point/active-models/src'

export class ApiError extends ActiveModel {
  /**
   * Дополнительная информация
   */
  @ActiveField()
  payload?: unknown = undefined

  /**
   * Тип ошибки
   */
  @ActiveField()
  type?: string = undefined

  /**
   * Заголовок данного типа ошибок
   */
  @ActiveField()
  title?: string = undefined

  /**
   * Общее сообщение по ошибке
   */
  @ActiveField()
  detail?: string = undefined

  /**
   * Status Code ошибки. Используется как признак сам по себе в комбинации с маршрутом запроса. А также помогает разделять ошибки по типу.
   */
  @ActiveField()
  status?: number = undefined
}
